var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoByponto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 120,
    viewBox: "0 0 150 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.8221 43.5484V21.9059H64.3586V65.1887H128.747V43.5484H85.8221Z",
    fill: "#FF00BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.415 65.1888C127.976 68.5723 127.1 71.7994 125.78 74.8679C123.802 79.4686 121.097 83.5121 117.667 86.992C114.235 90.472 110.25 93.2169 105.715 95.2204C101.178 97.2283 96.2924 98.2311 91.0583 98.2311H59.1542C53.9201 98.2311 49.0345 97.2283 44.4974 95.2204C39.9603 93.2169 35.9736 90.472 32.5459 86.992C29.1138 83.5121 26.4086 79.4707 24.4322 74.8679C22.4517 70.2652 21.4656 65.311 21.4656 59.9989C21.4656 54.6869 22.4517 49.7327 24.4322 45.132C26.4086 40.5314 29.1138 36.4901 32.5459 33.008C35.9758 29.5302 39.9625 26.7852 44.4974 24.7796C49.0345 22.7739 53.9201 21.771 59.1542 21.771H64.3607V0H59.1542C51.0108 0 43.3329 1.56426 36.1203 4.68849C28.9056 7.817 22.6238 12.0941 17.2749 17.5197C11.9218 22.9496 7.7056 29.3202 4.62421 36.6358C1.53857 43.9535 0 51.7426 0 59.9989C0 68.2552 1.53857 76.0486 4.62421 83.3621C7.7056 90.6798 11.9239 97.0525 17.2749 102.478C22.6238 107.906 28.9056 112.185 36.1203 115.309C43.3329 118.438 51.0087 120 59.1542 120H91.0583C99.1996 120 106.878 118.438 114.092 115.309C121.303 112.183 127.584 107.906 132.938 102.478C138.289 97.0525 142.505 90.6798 145.588 83.3621C148.015 77.5979 149.484 71.5401 150 65.1888H128.415Z",
    fill: "#00C9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoByponto);
export default __webpack_public_path__ + "static/media/logo-byponto.ece63cee2fcedd7f5a45f2b7f13ee813.svg";
export { ForwardRef as ReactComponent };